import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/teamspeak': {
    width: 511,
    height: 512,
    paths: [
      {
        d: 'M0.8 237.8C3.2 222.3 11.5 210.8 25.7 203.8 29.2 201.9 31.4 200.3 32.1 196 38.2 162.6 51.6 132 71.4 104.4 73.8 101.2 75.5 99 72.5 95 68.8 89.7 71.4 84.9 75.5 80.6 103.5 48.7 137.3 25.4 177.4 13.1 273.2-16.3 357.5 3.8 429.8 73.6 436.5 79.9 445.3 86.4 436.8 97.9 435.5 99.8 437.8 101.4 439 103 459.6 131 473.2 162.4 479.4 196.6 480.2 200.3 482.3 201.7 485.2 203 502.6 211.8 510.9 226.3 511.2 245.2 511.2 262.4 513.1 279.8 510.2 296.9 506.2 321.6 481 338.7 456.9 333.6 449.7 332 447.6 326.4 447.6 319.4 447.6 291.4 448.4 263 447.6 234.8 445.7 159.1 411.4 102 345.3 65.4 234.3 5 92.1 72.4 67.5 196.9 61.5 227.3 65.8 245.2 63.8 322.7 63.5 329.9 59.5 333.9 51.8 334.2 21 335.6 0 316.1 0 285.2V264.3M221.7 371.1C233.6 366.8 241.8 359.3 244.3 346.8 246.6 334.4 232.2 316.8 211.9 298.1 191 278.8 163.7 259 148.4 251.5 126.8 239.5 106.7 249.6 102.2 274.2 97.1 300.4 102.2 325.6 116.7 348.1 126.8 363.6 142.1 370.8 160.1 372.2 171.7 372.8 212.6 374.3 221.7 371.1M351.6 376.7C388.1 379.5 410.9 348.1 410 316.2 407.8 271.1 343.8 299.8 322.2 308.2 249 336.4 277.1 363.1 300 369M449.2 367.6C446.3 365.3 442 366.6 440.9 370 432.9 395.4 396.2 482.5 268.8 491.5 119.2 502 349.1 535.1 414.2 485.1 436.9 467.8 461.8 450.1 460.8 399.7 460.4 389.6 455.9 373 449.2 367.6'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/teamspeak.js
// module id = tnaq
// module chunks = 144